import { registerAs } from '@nestjs/config';
import { appConfigBase } from '../fixtures/appConfigBase';
export default registerAs('config', () => appConfigBase);
